import React, { type FC } from 'react';
import { connect, useSelector } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { favoriteContext } from 'app/contexts/betting/$favorites';
import { BettingWrapper } from 'app/modules/Betting';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import { Loader } from './components/Loader';
import { NoData } from './components/NoData';
import { SportsGrid } from './components/SportGrid';
import { entityLoading, entityRequested, matchIds } from './selectors/gridEntities';

type Favorites = {
  loading: boolean;
  requested: boolean;
  isFavoritesData: boolean;
};

const Favorites: FC<Favorites> = ({ loading, requested, isFavoritesData }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (!isLoggedIn) {
    return (
      <NoData isNoAuth />
    );
  }

  if (!requested || loading) {
    return <Loader />;
  }

  if (!isFavoritesData) {
    return <NoData />;
  }

  return (
    <BettingWrapper context={favoriteContext}>
      <SportsGrid />
    </BettingWrapper>
  );
};

const mapStateToProps = (state: ReduxState) => {
  return ({
    loading: entityLoading(state),
    requested: entityRequested(state),
    isFavoritesData: Boolean(matchIds(state).size),
  });
};

export default connect(mapStateToProps)(Favorites);
